export const en = {
    'update_success': 'Updated Successfully',
    'update_available': 'Update Available',
    'tap_to_update': 'Tap to restart and update',
    'update': 'Update',
    'new_version_available': 'New version available',
    'create_success': 'Created Successfully',
    'remove_success': 'Removed Successfully',
    'get_started': 'Get Started',
    'open_dashboard': 'Open Dashboard',
    'search': 'Search',
    'app_search_placeholder': 'Find..',
    'continue': 'Continue',
    'login': 'Login',
    'logout': 'Logout',
    'attention': 'Attention',
    'ok': 'Ok',
    'cancel': 'Cancel',
    'error': 'Error',
    'save': 'Save',
    'add': 'Add',
    'yes': 'Yes',
    'no': 'No',
    'next_btn': 'Next',
    'back_btn': 'Back',
    'connect_btn': 'Connect',
    'confirm_action': 'Confirm',
    'confirm_modal_title': 'Confirmation',
    'confirm_modal_content': 'Are you sure?',
    'cancel_btn': 'Cancel',
    'close': 'Close',
    'delete': 'Delete',
    'unknown': 'Unknown',
    'sign_up': 'Sign Up',
    'email': 'E-mail',
    'password': 'Password',
    'signup': 'Signup',
    'create': 'Create',
    'edit': 'Edit',
    'add_new': 'Add New',
    'deleted_success': 'Deleted Successfully',
    'upgrade_btn': 'Upgrade',
    'upgrade_plan_btn': 'Upgrade Plan',
    'sign_in_with_google': 'Sign In with Google',
    'sign_up_with_google': 'Sign Up with Google',
    'sign_in_with_telegram': 'Sign In with Telegram',
    'or': 'or',
    'na': 'N/A',
    'all_categories': 'All Categories',
    'no_items_found': 'No items found',
    'country': 'Country',
    'tags': 'Tags',
    'tag': 'Tag',
    'all': 'All',
    'dashboard': 'Dashboard',
    'last_30d': 'Last 30 days',
    'results': 'Results',
    'hide_btn': 'Hide',
    'updated': 'Updated',
    'updated_short': 'Upd.',
    'owner': 'Owner',
    'success_message': 'Operation completed successfully',
    'select_country': 'Select Country',
    'view_all': 'View All',
    'list': 'List',
    'plan': 'Plan',
    'info_updated': 'Info Updated',
    'show_more': 'Show More',
    'pause': 'Pause',
    'launch': 'Launch',
    'please_wait': 'Please wait..',
    'message': 'Message',
    'message_placeholder': 'Enter your message',
    'contact_email': 'Contact E-mail',
    'welcome': 'Welcome',
    'welcome_to': 'Welcome to :name',
    'status': 'Status',
    'enable_btn': 'Enable',
    'enabled': 'Enabled',
    'connection_error': 'Connection Error',
    'generating_exercises_title': 'Preparing Your Exercises',
    'generating_exercises_message': 'We\'re generating personalized exercises for you. This usually takes a few moments. Please try again shortly.',
    'app_motto_hallouminati': 'Everything for the Cyprus Culture Exam',
    'start_quiz_btn': 'Start Practice',
    // Daily Practice hub (home) — frames the 3 daily practice modes
    'practice_hub_title': 'Daily Practice',
    'practice_hub_count': '3 modes',
    'quick_quiz_title': 'Start Training',
    'quick_quiz_subtitle': 'Across all exam topics',
    'officials_card_title': 'Government Officials',
    'officials_card_subtitle': 'The President, ministers & key officials',
    'officials_list_title': 'Government Officials',
    // Quiz «Слова» sheet + My words (docs/hallouminati/question-words.md)
    'question_words_button': 'Words',
    'question_listen': 'Listen',
    'question_words_title': 'Words in this question',
    'my_words': 'My words',
    'my_words_learn': 'Learn',
    'my_words_learning': 'Learning',
    'question_words_known': 'known',
    // Tap a word in the question; adding is Adept (docs/hallouminati/question-words.md §Tap a word)
    'question_words_tap_hint': 'You can also tap a word in the question',
    'question_words_add': 'Add to dictionary',
    'question_words_adding': 'Adding…',
    'question_words_no_translation': 'Nothing to translate here',
    'question_words_add_limit': 'Daily limit reached, try tomorrow',
    'question_words_add_failed': "Couldn't add it, try again",
    'question_words_copy': 'Copy word',
    'question_words_copied': 'Copied',
    'question_words_missing_upsell': "This word isn't in our dictionary yet. With Adept you can add it: we'll translate it and find its base form.",
    'question_words_add_with_adept': 'Add with Adept',
    'question_words_paywall_title': 'Add any word',
    'question_words_paywall_subtitle': 'With Adept, any word from a question goes into the dictionary, translated and in its base form.',
    'my_words_paywall_title': 'Learn the words from questions',
    'my_words_paywall_subtitle': "With Adept, the word goes to My words and we keep reviewing it until it sticks.",
    'my_words_split': 'Learning :learning · Learned :learned',
    // The My words page (docs/hallouminati/question-words.md §My words)
    'my_words_tab_learning': 'Learning :n',
    'my_words_tab_learned': 'Learned :n',
    'my_words_tab_all': 'All :n',
    'my_words_study': 'Learn · :n',
    'my_words_review_all': 'Review all',
    'my_words_all_topics': 'All topics',
    'my_words_in_questions_one': 'in :n question',
    'my_words_in_questions_few': 'in :n questions',
    'my_words_in_questions_many': 'in :n questions',
    'my_words_today': 'today',
    'my_words_tomorrow': 'tomorrow',
    'my_words_in_days': 'in :n days',
    'my_words_exam_questions': 'In exam questions: :n',
    'my_words_more_questions_one': 'And :n more',
    'my_words_more_questions_few': 'And :n more',
    'my_words_more_questions_many': 'And :n more',
    'my_words_know': 'I know it',
    'my_words_relearn': 'Learn again',
    'my_words_remove': 'Remove from My words',
    'my_words_removed': 'removed',
    'my_words_empty': 'Add words with the «Words» button in questions',
    'my_words_tab_empty': 'No words here yet',
    'my_words_save_failed': 'Could not save. Please try again.',
    // Hallouminati vocab tab — the key exam words (docs/hallouminati/vocab-trainer.md §The tab)
    'vocab_exam_words': 'Key exam words',
    'vocab_step': 'Stage :n of :total',
    'vocab_coverage_label': 'Familiar words in exam questions',
    'vocab_left_to_learn': 'Left to learn',
    'vocab_status_known': 'Known',
    'vocab_status_learned': 'Learned',
    'vocab_status_learning': 'Learning',
    'vocab_status_remaining': 'New',
    'vocab_skip_known': 'Skip words I know',
    'vocab_mistake_words': 'Words from questions you got wrong',
    'vocab_list_tab_new': 'New :n',
    'vocab_learned_words': 'Learned words',
    'vocab_struggling_words': 'Struggling words',
    'vocab_sort_prompt': "Tap the words you don't know",
    'vocab_sort_learn': 'To learn: :n',
    'vocab_sort_known': 'Known: :n',
    'vocab_sort_done': 'Done',
    'vocab_sort_more': 'More',
    'vocab_sort_result_known': 'Known: :n',
    'vocab_sort_result_learn': 'To learn: :n. They are already in your practice.',
    'vocab_sort_empty': 'Every word from the exam questions is sorted',
    'vocab_sort_save_failed': "Couldn't save. Try again.",
    // Ladder card (docs/hallouminati/vocab-trainer.md §The ladder)
    'ladder_context_prompt': 'What does the marked word mean?',
    'word_status_new': 'New',
    'word_status_learning': 'Learning :n/:total',
    'word_status_learned': 'Learned',
    'word_status_known': 'Known',
    'word_retired_toast': "won't be shown again",
    'undo': 'Undo',
    'session_exam_coverage': 'Known words in the exam questions',
    // Vocab tab — "Exam vocabulary" section (docs/exam-content/07-vocab-deck.md)
    'exam_vocab_title': 'Exam vocabulary',
    'exam_vocab_subtitle': 'Words from real exam questions — so you read the question instead of guessing it.',
    'vocab_category_question_words': 'Question words',
    'vocab_category_institutions': 'Institutions and acronyms',
    'vocab_category_politics_law': 'Politics and law',
    'vocab_category_geography': 'Geography',
    'vocab_category_history_culture': 'History and culture',
    'vocab_category_religion_holidays': 'Religion and holidays',
    'vocab_category_daily_life': 'Everyday life',
    'officials_progress': ':learned / :total learned',
    'officials_status_new': 'New',
    'officials_status_learning': 'Learning',
    'officials_status_learned': 'Learned',
    'officials_updated': 'Verified up to date · October 2026',
    'geo_quiz_card_title': 'Map of Cyprus',
    'geo_quiz_card_description': 'Learn Cyprus districts, cities, villages, and landmarks on the map.',
    'geo_quiz_card_subtitle': 'Districts, cities, villages & landmarks',
    'geo_quiz_start_btn': 'Start Geo Practice',
    'geo_quiz_progress_total': ':total places to learn',
    'geo_quiz_prompt_locate_place': 'Where is :place on the map?',
    'geo_quiz_prompt_identify_place': 'Which place is marked on the map?',
    'geo_quiz_prompt_area_of_place': 'In which area is :place located?',
    'geo_quiz_prompt_locate_area': 'Which area on the map is :place?',
    'geo_quiz_prompt_identify_area': 'Which area is highlighted?',
    'geo_quiz_no_session_title': 'No geo exercises available yet',
    'geo_quiz_no_session_body': 'Come back later — new content is added regularly.',
    'streak_practice_daily': 'Practice each day so your streak won\'t reset!',
    'exam_progress_title': 'Your Exam Preparation Progress',
    'exam_language_notice': 'Consider switching to Greek language practice more often. The actual exam will be in Greek, so it\'s important to familiarize yourself with Greek terminology.',
    'recent_mistakes_title': 'Recent Mistakes',
    'practice': 'Practice',
    'grammar': 'Grammar',
    'practice_hub_subtitle': 'Train the four exam skills',
    'practice_readiness_blurb': 'Track your progress across all four skills',
    'practice_start_cta': 'Start',
    'practice_unlock_soon': 'Unlocking soon',
    'readiness_tier_begin': 'Pick a skill below and start your first session.',
    'readiness_tier_start': 'Nice start — keep the momentum going! 🔥',
    'readiness_tier_progress': "You're building real progress. Keep it up!",
    'readiness_tier_half': "More than halfway there — you've got this. 💪",
    'readiness_tier_almost': 'Almost exam-ready. Finish strong!',
    'readiness_tier_ready': "You're exam-ready! 🎉",
    'grammar_hub_subtitle': 'Practice rules and patterns',
    'coming_soon': 'Coming soon',
    'practice_reading': 'Reading',
    'practice_reading_desc': 'Read short passages and answer questions',
    'practice_listening': 'Listening',
    'practice_listening_desc': 'Listen to native speakers and check comprehension',
    'practice_speaking': 'Speaking',
    'practice_speaking_desc': 'Describe pictures and chat with your AI tutor out loud',
    'practice_writing': 'Writing',
    'practice_writing_desc': 'Build sentences and write real exam-style texts',
    'speaking_subtitle': 'Train pronunciation and fluency',
    'speaking_pictures_tab': 'Pictures',
    'speaking_dialogues_tab': 'Dialogues',
    // Realtime voice dialogues
    'dialogue_hero_title': 'Live role-play',
    'dialogue_hero_desc': 'Pick a scene and have a real spoken Greek conversation with an AI partner',
    'dialogue_pick_scenario': 'Scenarios',
    'dialogue_no_scenarios': 'No scenarios available yet',
    'dialogue_load_failed': 'Failed to load dialogues',
    'dialogue_choose_role': 'Choose your role',
    'dialogue_role_hint': "You'll speak as your character — the AI plays the other.",
    'dialogue_role_fixed_hint': 'This scenario has a set role — the AI plays the other side.',
    'dialogue_partner_level': "Partner's Greek level",
    'dialogue_continue': 'Continue',
    'dialogue_pick_role_cta': 'Choose your role first',
    'dialogue_back_to_dialogues': 'Back to dialogues',
    'dialogue_your_role': 'Your role',
    'dialogue_your_task': 'Your task',
    'dialogue_show_translation': 'Show translation',
    'dialogue_hide_translation': 'Hide translation',
    'dialogue_tips_phrases': 'Tips & phrases',
    'dialogue_prep_title': 'What you need to know',
    'dialogue_prep_subtitle': 'Words, questions & an example to prepare',
    'dialogue_prep_words': 'Useful words',
    'dialogue_prep_ask': 'What you can ask',
    'dialogue_prep_example': 'Example dialogue',
    'dialogue_prep_you': 'you',
    'dialogue_conversation': 'Conversation',
    'dialogue_conversation_hint': 'Your conversation will appear here…',
    'dialogue_start': 'Start dialogue',
    'dialogue_connecting': 'Connecting…',
    'dialogue_connected_listen': 'Listen, then hold to talk',
    'dialogue_connected_speak_first': 'Hold the button to speak first',
    'dialogue_hold_to_talk': 'Hold to talk',
    'dialogue_recording': 'Recording — release to send',
    'dialogue_recording_short': 'Recording…',
    'dialogue_hold_too_short': 'Hold the button while you speak',
    'dialogue_finish': 'Finish',
    'dialogue_finished': 'Dialogue finished',
    'dialogue_mic_denied': 'Microphone access is needed for voice dialogues',
    'dialogue_connect_failed': 'Could not connect. Please try again.',
    'dialogue_retry': 'Retry connection',
    'dialogue_back': 'Go back',
    'dialogue_locked_title': 'Keep the conversation going with GreekBrain Pro',
    'dialogue_locked_body': "You've used your free AI tries. Subscribe to keep practising live voice dialogues.",
    'dialogue_quota_title': "You've used all your voice dialogues this month",
    'dialogue_quota_body': 'Your monthly limit resets at the start of next month. Upgrade for more live practice whenever you want.',
    'dialogue_activate_pro': 'Activate GreekBrain Pro',
    'dialogue_all_free': 'Everything else — pictures, vocabulary and practice — stays free.',
    'dialogue_evaluation': 'Evaluation',
    'dialogue_evaluation_soon': 'AI feedback for your dialogue is coming soon.',
    'dialogue_evaluation_pending': 'Grading your dialogue… this takes about half a minute.',
    'dialogue_evaluation_unavailable': 'This session was not graded.',
    'dialogue_mode_exam_tag': 'Exam mode',
    'dialogue_crit_tasks': 'Tasks done',
    'dialogue_crit_interaction': 'Interaction',
    'dialogue_crit_language': 'Language',
    'dialogue_crit_register': 'Register',
    'dialogue_crit_relevance': 'Answers the question',
    'dialogue_crit_grammar': 'Grammar',
    'dialogue_crit_vocabulary': 'Vocabulary',
    'dialogue_crit_development': 'Full sentences',
    'dialogue_band_above': 'Above A2',
    'dialogue_band_meets': 'Meets A2',
    'dialogue_band_borderline': 'Borderline',
    'dialogue_band_below': 'Below A2',
    'dialogue_strengths': 'What worked',
    'dialogue_improvements': 'Next time',
    'dialogue_better_turns': 'Say it better',
    'dialogue_no_transcript': 'No transcript was saved for this session.',
    'dialogue_mode_label': 'How do you want to practise?',
    'dialogue_mode_voice': 'Talk with AI',
    'dialogue_mode_voice_subtitle': 'Live role-play',
    'dialogue_mode_chip': 'Construct phrases',
    'dialogue_mode_chip_subtitle': 'Reply by tapping Greek words',
    'dialogue_mode_progress': ':trained / :total trained',
    'dialogue_mode_mastered_hint': "You've nailed every dialogue — push your speaking with the live AI.",
    'dialogue_mode_mastered_badge': 'Mastered',
    'dialogue_mode_recommended_badge': 'Try next',
    'random_dialogue_title': 'Random role',
    'random_dialogue_subtitle': 'We pick the scenario & role — just like the real exam',
    'random_picture_title': 'Random picture',
    'random_picture_subtitle': 'We pick the picture for you — just like the real exam',
    'random_sheet_title_dialogue': 'Random dialogue',
    'random_sheet_title_picture': 'Random picture',
    'random_sheet_subtitle': 'A random topic, just like the real exam',
    'random_start_cta': 'Start practice',
    'dialogue_pick_mode_cta': 'Choose how to practise',
    'dialogue_chip_loading': 'Loading conversation…',
    'dialogue_chip_no_conversations': 'No practice conversations for this scenario yet.',
    'dialogue_chip_translate_prompt': 'Reply in Greek:',
    'dialogue_chip_send': 'Send',
    'dialogue_chip_replay': 'Replay',
    'dialogue_chip_show_translation': 'Translate',
    'dialogue_chip_reveal_answer': 'Show the answer',
    'dialogue_chip_correct_answer': 'Correct answer',
    'dialogue_chip_continue': 'Continue',
    'dialogue_chip_summary_title': 'Dialogue complete',
    'dialogue_chip_summary_subtitle': 'Nicely done. Practice another to lock it in.',
    'dialogue_chip_stat_turns': 'Lines spoken',
    'dialogue_chip_stat_errors': 'Mistakes',
    'dialogue_chip_practice_again': 'Practice again',
    'dialogue_chip_back_to_all': 'Back to all dialogues',
    'picture_mode_label': 'How do you want to practise?',
    'picture_mode_voice': 'Speak & be graded',
    'picture_mode_voice_subtitle': 'AI transcribes & scores your Greek',
    'picture_mode_chip': 'Build sentences',
    'picture_mode_chip_subtitle': 'Tap Greek words to construct the description',
    'picture_mode_progress': ':trained / :total trained',
    'picture_mode_mastered_hint': "You've nailed every picture — push your speaking with the live AI grader.",
    'picture_mode_mastered_badge': 'Mastered',
    'picture_mode_recommended_badge': 'Try next',
    'picture_pick_mode_cta': 'Choose how to practise',
    'picture_chip_start': 'Start chip practice',
    'picture_chip_loading': 'Loading description…',
    'picture_chip_translate_prompt': 'Say in Greek:',
    'picture_chip_no_translation': 'No translation for this sentence yet — try to assemble the Greek from the chips below.',
    'picture_chip_summary_title': 'Description complete',
    'picture_chip_summary_subtitle': 'Nicely done. Practice another to lock it in.',
    'picture_chip_stat_sentences': 'Sentences built',
    'picture_chip_stat_errors': 'Mistakes',
    'picture_chip_practice_again': 'Practice again',
    'picture_chip_back_to_all': 'Back to all pictures',
    'writing_subtitle': 'A2 ΚΕΓ letter prep — assemble exam-passing letters from a fixed toolkit.',
    'writing_readiness_blurb': 'Master the 130-phrase toolkit — then prove it with a full letter.',
    'writing_curriculum_load_failed': 'Failed to load writing curriculum.',
    'writing_no_units': 'No writing units configured yet.',
    'writing_unit_complete': 'Complete',
    'writing_unit_locked': 'Locked — finish the previous unit',
    'writing_unit_locked_toast': 'Finish the previous unit to unlock this one.',
    'writing_phrases_short': 'phrases',
    'writing_phrases_typed': 'typed',
    'writing_unit_anatomy_subtitle': 'Read the skeleton',
    'writing_anatomy_tag': 'Anatomy',
    'writing_phase_anatomy': 'Anatomy',
    'writing_phase_shared_core': 'Shared core',
    'writing_phase_informal_shell': 'Informal shell',
    'writing_phase_slot_fill_informal': 'Slot-fill — informal',
    'writing_phase_official_shell': 'Official shell',
    'writing_phase_slot_fill_official': 'Slot-fill — official',
    'writing_phase_anatomy_intro': 'Before drilling phrases, see the two letter skeletons you\'ll assemble.',
    'writing_phase_shared_core_intro': 'These slots — where, when, what, cost, duration — show up in every letter, formal or not. Build them once.',
    'writing_phase_informal_shell_intro': 'The friendly-email slots: greeting, news, event, reaction, invitation, closing.',
    'writing_phase_slot_fill_informal_intro': 'Mix the informal slots until you can chain a full letter without stopping.',
    'writing_phase_official_shell_intro': 'The announcement slots: header, title, opening, what, where, when, cost, duration, call-to-action, sign-off.',
    'writing_phase_slot_fill_official_intro': 'Mix the official slots into full exam-style announcements.',
    'writing_tab_curriculum': 'Curriculum',
    'writing_tab_phrases': 'Phrases',
    'writing_tab_composition': 'Composition',
    'writing_phrases_title': 'Phrase Drill',
    'writing_phrases_mastered_label': 'Mastered',
    'writing_phrases_per_session': 'Per session',
    'writing_phrases_start_drill': 'Start phrase drill',
    'writing_phrases_empty_title': 'No phrases marked yet',
    'writing_phrases_empty_blurb': 'Ask an admin to mark some phrases for the typing drill.',
    'writing_phrases_filter_all': 'All',
    'writing_phrases_filter_new': 'New',
    'writing_phrases_filter_learning': 'Learning',
    'writing_phrases_filter_mastered': 'Mastered',
    'writing_phrases_section_practice_next': 'Practice next',
    'writing_phrases_section_practice_next_hint': 'Weak items the next drill hits first.',
    'writing_phrases_section_new': 'Fresh phrases',
    'writing_phrases_section_new_hint': 'Unseen — shortest shown first.',
    'writing_typing_pool_empty_toast': 'No phrases marked for the typing drill yet.',
    'writing_typing_instruction': 'Translate to Greek',
    'writing_typing_hint_label': 'Hint',
    'writing_typing_show_hint_btn': 'Show answer',
    'writing_typing_hint_disclaimer': "Type it to practice — won't count as correct.",
    'writing_typing_hint_used': "You used the hint, so this one won't count as learned yet.",
    'writing_anatomy_title': 'Anatomy of a letter',
    'writing_anatomy_subtitle': 'Two skeletons cover every ΚΕΓ A2 writing prompt.',
    'writing_anatomy_intro': 'The exam asks for two letters: an informal one to a friend, and an official announcement. Each is built from a fixed sequence of slots — fill them in order and you have a passing answer.',
    'writing_anatomy_load_failed': 'Failed to load anatomy.',
    'writing_anatomy_complete_cta': 'Got it — mark as complete',
    'writing_anatomy_complete_failed': 'Could not save progress — please try again.',
    'writing_anatomy_informal': 'Informal letter (to a friend)',
    'writing_anatomy_official': 'Official announcement / formal letter',
    'writing_composition_title': 'Free Composition',
    'writing_composition_subtitle': 'Write a full letter, get instant AI feedback against the ΚΕΓ A2 rubric.',
    'writing_composition_locked_title': 'Free composition is locked',
    'writing_composition_locked_blurb': 'Finish the slot-fill (informal) units in the curriculum to unlock free composition.',
    'writing_prompts_load_failed': 'Failed to load prompts.',
    'writing_no_prompts': 'No composition prompts configured yet.',
    'writing_available_prompts': 'Available prompts',
    'writing_history_title': 'Past submissions',
    'writing_history_empty': 'No submissions yet — pick a prompt above to start.',
    'writing_letter_informal': 'Informal',
    'writing_letter_official': 'Official',
    'writing_words_short': 'words',
    'writing_required_points': 'Required points',
    'writing_textarea_placeholder': 'Γράψτε εδώ… (write your letter in Greek)',
    'writing_too_short': 'Below target — keep going.',
    'writing_too_long': 'Over target — trim a bit.',
    'writing_submit_failed': 'Could not grade your submission. Your text was saved — try again.',
    'writing_submit': 'Submit for grading',
    'writing_grading': 'Grading…',
    'writing_prompt_not_found': 'Prompt not found.',
    'writing_result_title': 'Your result',
    'writing_result_load_failed': 'Failed to load submission.',
    'writing_grade_pending': 'Grading did not complete',
    'writing_grade_pending_blurb': 'Your text was saved. Try submitting again from the composition page.',
    'writing_kgp_score': 'ΚΕΓ A2 score',
    'writing_pass': 'Pass — at or above the A2 threshold.',
    'writing_fail': 'Below pass — see suggestions below.',
    'writing_rubric_title': 'Rubric breakdown',
    'writing_rubric_register': 'Register matches the letter type',
    'writing_rubric_greeting': 'Greeting present',
    'writing_rubric_closing': 'Closing present',
    'writing_rubric_required_prefix': 'Required:',
    'writing_your_text': 'Your text',
    'writing_legend_matched': 'used from toolkit',
    'writing_legend_error': 'error span',
    'writing_errors_title': 'Errors',
    'writing_accent_errors': 'Accent / spelling fixes',
    'writing_suggestions_title': 'Phrases you know but didn’t use',
    'writing_matched_title': 'Used from your toolkit',
    'writing_matched_count': 'learned phrase(s) confirmed in context.',
    'writing_try_another': 'Try another prompt',
    'picture_describe_title': 'Describe a picture',
    'picture_describe_desc': 'Record yourself describing the scene in Greek — get instant feedback',
    'picture_describe_prompt': 'Describe what you see',
    'picture_suggested_vocab': 'Try using',
    'picture_record_press_to_start': 'Press the microphone and describe the picture in Greek.',
    'picture_recording_in_progress': 'Recording… tap to stop.',
    'picture_processing': 'Transcribing your Greek and evaluating…',
    'picture_magic_title': 'Speak it — AI does the rest',
    'picture_magic_subtitle': 'Tap the button below and describe the picture in Greek — just like the real exam. AI transcribes your speech and scores it on exam criteria.',
    'picture_tap_to_speak': 'Tap to speak',
    'picture_tap_to_speak_sub': 'AI transcribes & scores your Greek',
    'picture_recording_finish_hint': 'Tap to stop & get your score',
    'picture_too_short': 'Recording too short. Please speak for a bit longer.',
    'picture_record_again': 'Record again',
    'picture_record_again_short': 'Retry',
    'picture_next_short': 'Next',
    'picture_back_to_pictures': 'Back to pictures',
    'picture_show_hints': 'Show hints',
    'picture_hide_hints': 'Hide hints',
    'picture_hint_questions_label': 'Think about',
    'picture_personal_question_label': 'Answer about yourself',
    'picture_personal_answer_example_label': 'Answering about yourself',
    'picture_description_label': 'Example description (Greek)',
    'picture_level_basic': 'Basic',
    'picture_level_standard': 'Standard',
    'picture_level_advanced': 'Advanced',
    'picture_hint_vocab_label': 'Useful Greek words',
    'picture_practice_vocab_button': 'Practice vocabulary for this picture',
    'picture_vocab_title': 'Picture vocabulary',
    'picture_vocab_subtitle': 'Words you need to describe most ΚΕΓ A2 picture prompts',
    'picture_vocab_practice_all': 'Practice all words',
    'picture_vocab_view_all': 'View all words',
    'picture_vocab_load_error': 'Could not load vocabulary',
    'picture_vocab_coming_soon': 'Vocabulary coming soon',
    // Shared vocabulary-list component
    'vocab_filter_all': 'All',
    'vocab_state_new': 'New',
    'vocab_state_learning': 'Learning',
    'vocab_state_mastered': 'Mastered',
    'vocab_showing': 'Showing',
    'vocab_of': 'of',
    'prev_page': 'Previous page',
    'next_page': 'Next page',
    'dialogue_practice_vocab_button': 'Practice vocabulary for this dialogue',
    'dialogue_vocab_title': 'Dialogue vocabulary',
    'dialogue_vocab_subtitle': 'Words you need to hold most spoken Greek conversations',
    'dialogue_vocab_practice_all': 'Practice all dialogue words',
    'dialogue_vocab_view_all': 'View all words',
    'dialogue_vocab_load_error': 'Could not load vocabulary',
    'dialogue_vocab_coming_soon': 'Vocabulary coming soon',
    'picture_strengths': 'Strengths',
    'picture_problems': 'Problems',
    'picture_improve': 'To improve',
    'picture_model_answer': 'Example answer',
    'picture_next_picture': 'Next picture',
    'picture_grade_failed': 'Could not grade your description. Try again.',
    // Out-of-usage upsell shown when the learner taps record without AI credits.
    'picture_locked_title': 'Get AI feedback with GreekBrain Pro',
    'picture_locked_body': "You've used your free AI tries — activate Pro to keep getting instant feedback on your spoken descriptions.",
    'picture_quota_title': "You've used all your picture descriptions this month",
    'picture_quota_body': 'Your monthly limit resets at the start of next month. Upgrade for more AI feedback whenever you want.',
    'picture_activate_pro': 'Activate GreekBrain Pro',
    'picture_gate_try_chip': 'Build sentences instead',
    'picture_gate_chip_free': 'Building sentences with chips stays free.',
    'picture_load_failed': 'Failed to load pictures',
    'picture_status_not_attempted': 'Not yet',
    'picture_insufficient_evidence': 'Not enough to evaluate',
    'picture_no_speech': '(no speech detected)',
    'picture_transcript_label': 'Your description',
    'picture_total_score_label': 'Total score',
    'picture_band_below_a2': 'Below A2',
    'picture_band_a2_borderline': 'A2 borderline',
    'picture_band_a2_meets_target': 'Meets A2',
    'picture_band_above_a2': 'Above A2',
    'picture_criterion_grammar': 'Grammar',
    'picture_criterion_pragmatic': 'Pragmatic',
    'picture_criterion_pronunciation': 'Pronunciation',
    'picture_criterion_vocabulary': 'Vocabulary',
    'picture_criterion_communicative': 'Communication',
    'picture_mic_unsupported': 'Audio recording is not supported in this environment.',
    'mic_permission_denied': 'Microphone permission denied',
    'greek': 'Greek',
    'russian': 'Russian',
    'english': 'English',
    'questions_mastered': 'Questions Mastered',
    'mastery_greek_only_title': 'Greek is what counts',
    'mastery_greek_only_desc': 'You\'ve mastered a question once you answer it correctly in Greek — the language of the real exam. Practising in English or Russian is great for learning, but only your Greek answers move this number.',
    'readiness_formula_note': 'It counts the core questions you\'ve learned, weighted by how much each topic counts in the real exam. Citizenship needs 60%, long-term residence 50%.',
    'readiness_how_lead': 'Your expected score on the exam.',
    'readiness_extra_note': 'Harder and rare are harder versions of questions ("which is NOT true", "fill in the blank") and rare facts. They unlock after the core and come on top of the estimate. Tap "Harder and rare" to practise only those.',
    'topic_extra_note': 'Harder and rare are harder versions of questions ("which is NOT true", "fill in the blank") and rare facts. They unlock after the core and are not in the percentage. Tap "Harder and rare" to practise only those.',
    'topic_how_title': 'Topic progress',
    'topic_how_lead': 'The percentage is the share of this topic\'s core questions you\'ve learned.',
    'readiness_core_label': 'Core',
    'readiness_extra_label': 'Harder and rare',
    'qstatus_new': 'New',
    'qstatus_learning': 'Learning',
    'qstatus_review': 'Review',
    'qstatus_mastered': 'Mastered',
    'qstatus_new_desc': 'A question you haven\'t practised yet — give it a go!',
    'qstatus_learning_desc': 'You\'re still getting the hang of this one. Keep going! 💪',
    'qstatus_review_desc': 'You\'ve answered this correctly before. Get it right in Greek 🇬🇷 to master it for the exam.',
    'qstatus_mastered_desc': 'You\'ve answered this correctly in Greek 🇬🇷 — mastered! 🎉',
    'qstatus_practised': 'Practised :count×',
    'qstatus_last_seen_today': 'last seen today',
    'qstatus_last_seen_days': 'last seen :days d ago',
    'avg_accuracy': 'Average Accuracy',
    'lang_distibution_title': 'Language Distribution',
    'correct_answer': 'Correct answer',
    'your_answer': 'Your answer',
    'question': 'Question',
    'of': 'of',
    'correct': 'correct',
    'report_issue': 'Report Issue',
    'try_again_btn': 'Try again',
    'back_home': 'Back home',
    'practise_mistakes_btn': 'Practise your mistakes',
    'perfect_session': 'Perfect Session!',
    'session_summary_sub': 'You\'re making great progress!',
    'excellent_work': 'Excellent Work!',
    'excellent_work_sub': 'You\'re doing fantastic!',
    'good_job': 'Good Job!',
    'good_job_sub': 'Keep up the good work!',
    'needs_improvement': 'Keep Practicing!',
    'needs_improvement_sub': 'Practice makes perfect.',
    'keep_trying': 'Don\'t Give Up!',
    'keep_trying_sub': 'Every mistake is a learning opportunity.',
    'perfect_score': 'Perfect Score!',
    'out_of': 'out of',
    'you_got': 'You got',
    'questions_correct': 'questions correct!',
    'cyprus_expert': 'Amazing! You are a Cyprus expert!',
    'great_job': 'Great job! You know Cyprus well!',
    'good_effort': 'Good effort! Keep learning about Cyprus!',
    'keep_practice': 'Keep practicing to learn more about Cyprus!',
    'result_above_pass': 'The exam pass mark is 60% — you\'re :n% above it.',
    'result_below_pass': 'The exam needs 60% — you were :n% short.',
    'result_correct_of': ':score of :total answered correctly',
    'day_streak_title': 'day streak!',
    'report_success_message': 'Thank you for your report. We will review it soon.',
    'time_lbl': 'Time',
    'answered_lbl': 'Answered',
    'result_time_meta': ':time total · :per s per question',
    'result_time_meta_exam': ':time of :limit · :per s per question',
    'show_translation': 'Show translation',
    'hide_translation': 'Hide translation',
    'tap_words_below': 'Tap words below',
    'vocabulary': 'Vocabulary',
    'handbook': 'Guide',
    'exams': 'Exams',
    'exams_mock_title': 'Practice exam',
    'exams_mock_body': '25 questions across every topic in 45 minutes — as on the real exam. You need 60% to pass.',
    'exams_mock_start': 'Start practice exam',
    'exams_ai_title': 'AI exam',
    'exams_ai_subtitle': 'Questions at the July 2026 level, updated in October',
    'exam_new_badge': 'new',
    'official_passed': 'Passed',
    'official_not_passed': 'Not passed — you need 60%',
    'official_passed_count': ':passed of :total passed',
    'home': 'Home',
    'coming_soon_title': 'Coming in a few days!',
    'essential_words': 'Essential Words & Phrases',
    'vocabulary_description_hallouminati': 'Learn the essential vocabulary that appears most frequently in Cyprus Culture exam.',
    'vocabulary_description_greekbrain': 'Master only the words you need for the official ΚΕΓ A2 Greek exam',
    'ai_exam_title': 'AI-Powered Exam Simulation',
    'ai_exam_description': 'Challenge yourself with AI-generated questions tailored to the official Cypriot culture exam format.',
    'ai_exam_button': 'Start AI Practice',
    'real_exam_button': 'Take a practice exam',
    'real_exam_title': 'Practice exam',
    'real_exam_description': 'Practice with the exact format and timing of the real Cyprus culture exam. 25 questions in exam conditions.',
    'official_exams_title': 'Official past exams',
    'official_exams_description': 'Study with real questions from previous years. Perfect for understanding question patterns and difficulty levels.',
    'questions_num': ':num questions',
    'exam_coming_soon': 'Coming soon',
    'exam_discuss_tg': 'Discuss the exam in our group',
    'july2026_banner_title': 'July 2026 exams',
    'july2026_banner_subtitle': 'Both variants from the 4 July sitting are available.',
    'july2026_banner_variant1': 'Variant I',
    'july2026_banner_variant2': 'Variant II',
    'soon': 'soon',
    'practice_session': 'Practice Session',
    'my_progress': 'My Progress',
    'word': 'Word',
    'show_answer': 'Show Answer',
    'dont_know': 'I Don\'t Know',
    'mark_learned': 'Mark as learned',
    'mark_learned_sheet_desc': 'Mark as learned and stop reviewing it',
    'meaning': 'Meaning',
    'words_learned': 'Words Learned',
    'daily_streak': 'Daily Streak',
    'daily_goal': 'Daily Goal',
    'days_in_row': 'days in a row',
    'today': 'Today',
    'words_practiced': 'words practiced',
    'accuracy': 'Accuracy',
    'correct_answers': 'Correct Answers',
    'mistakes': 'Mistakes',
    'recent_words': 'Recently Learned',
    'keep_learning': 'Keep learning new words every day',
    'start_practice': 'Start Practice',
    'speed': 'Speed',
    'speed_steady': 'Steady',
    'speed_focused': 'Focused',
    'speed_blazing': 'Blazing',
    'speed_speedy': 'Speedy',
    'practice_more': 'Practice More',
    'back_to_dashboard': 'Back to Dashboard',
    'progress': 'Progress',
    'skill_progress': 'Skill Progress',
    'nowordslearned_placeholder': 'No words learned yet. Keep practicing!',
    'have_question_btn': 'Need help?',
    'what_is_the_issue': 'What is the issue with this question?',
    'additional_details': 'Additional Details',
    'additional_details_placeholder': 'Please provide any additional information that might help us understand the issue...',
    'submit_report': 'Submit Report',
    'report_reason_wrong_translation': 'Wrong Translation',
    'report_reason_misleading': 'Question is Misleading',
    'report_reason_incorrect_answer': 'Incorrect Answer Marked as Correct',
    'report_reason_unclear_options': 'Answer Options are Unclear',
    'report_reason_duplicate': 'Duplicate Question',
    'report_reason_other': 'Other Issue',
    'report_comment_min_length': 'Please provide at least 10 characters',
    'report_error_message': 'Failed to submit report. Please try again.',
    'report_reason_required': 'Please select a reason',
    // Practice report reasons (for grammar, comprehension exercises)
    'practice_report_reason_wrong_answer': 'Correct Answer is Wrong',
    'practice_report_reason_confusing_question': 'Question is Confusing',
    'practice_report_reason_unclear_options': 'Answer Options are Unclear',
    'practice_report_reason_wrong_explanation': 'Explanation is Incorrect',
    'practice_report_reason_other': 'Other Issue',
    // Vocab report reasons (for vocabulary review exercises)
    'practice_report_reason_wrong_translation': 'Translation is Wrong',
    'practice_report_reason_incorrect_pronunciation': 'Pronunciation is Incorrect',
    'practice_report_reason_wrong_word_class': 'Word Class is Wrong',
    'practice_report_reason_missing_meaning': 'Missing Meaning/Definition',
    'practice_report_reason_wrong_example': 'Example Sentence is Wrong',
    // Geo report reasons (for Cyprus geography quiz places)
    'practice_report_reason_wrong_location': 'Place is in the Wrong Location',
    'practice_report_reason_wrong_name': 'Place Name is Wrong',
    'practice_report_reason_wrong_description': 'Description is Incorrect',
    'practice_report_reason_missing_description': 'Description is Missing',
    // Picture-speaking AI evaluation report reasons (beta)
    'practice_report_reason_speech_not_recognized': 'My speech was transcribed incorrectly',
    'practice_report_reason_score_unfair': 'The score seems unfair',
    'practice_report_reason_wrong_feedback': 'Feedback or corrections are wrong',
    'practice_report_reason_bad_example_answer': 'Example answer is wrong or unnatural',
    'practice_report_reason_technical_problem': 'Something did not work (technical issue)',
    'picture_report_evaluation_issue': 'Report an issue with this evaluation',
    'total_questions': 'Total Questions',
    'exam_readiness': 'Exam Readiness',
    'try_greek': 'Try Greek!',
    'questions_attempted': 'Questions Attempted',
    'practice_topic': 'Practice Topic',
    'quick_practice': 'Quick Practice',
    'topic_practice_all': 'All :count',
    'topic_learned_of': ':learned of :total learned',
    'topic_mastery': 'Topic Mastery',
    'show_less': 'Show Less',
    'match_pairs_hint': 'Choose matching pairs',
    'choose_correct_translation': 'Choose the correct translation',
    'awesome': 'Awesome',
    'incorrect': 'Incorrect',
    'got_it': 'Got It',
    'correct_answer_is': 'Correct Answer',
    'show_hint': 'Show explanation',
    'check_btn': 'Check',
    'words_struggling_with': 'Words You Struggle With',
    'no_struggling_words': 'No words you\'re currently struggling with',
    'recently_mastered': 'Recently Mastered',
    'no_mastered_words': 'No words mastered yet',
    'see_all': 'See all',
    'practice_history': 'Practice History',
    'no_practice_history': 'No practice records yet. Keep learning!',
    'goal_completed': 'Daily goal completed!',
    'goal_exceeded': 'Goal exceeded! Great job!',
    'words_left': 'words left',
    'day_in_row': 'day in a row',
    'motivation_quote': 'Every word you learn is a step closer to fluency',
    'keep_going': 'Keep going!',
    'total': 'total',
    'words_mastered': 'Words mastered',
    'practice_these_words': 'Practice These Words',
    'struggling_words_description': 'Focus on these words to improve your vocabulary skills. These are words where your accuracy is below 70%.',
    'mastery_progress': 'Mastery Progress',
    'last_practiced': 'Last practiced',
    'struggling_words_empty_message': 'Great job! You\'re doing well with all your vocabulary.',
    'repetition_quote': 'Repetition is the mother of learning',
    'practice_consistently': 'Practice these words consistently for best results!',
    'word_collection': 'Word Collection',
    'vocabulary_progress': 'Vocabulary Progress',
    'words': 'words',
    'complete': 'complete',
    'mastered_words': 'Mastered',
    'learning_words': 'Learning',
    'new_words': 'New',
    'all_words': 'All Words',
    'showing': 'Showing',
    'track_your_progress': 'Track your progress',
    'no_words_found': 'No words found',
    'start_practicing_to_see_words': 'Start practicing to see your vocabulary here',
    'no_words_in_category': 'No words in this category yet',
    'review_mastered_words': 'Review Mastered Words',
    'learn_new_words': 'Learn New Words',
    'last_practice': 'Last Practice',
    'yesterday': 'Yesterday',
    'ago': 'ago',
    'start_practicing_message': 'Start practicing to add words to your collection.',
    'all_words_seen': 'You\'ve seen all available words!',
    'congratulations_all_words': 'Congratulations! You\'ve been introduced to all the words in our database.',
    'tip_review_regularly': 'Tip: Review mastered words regularly to keep them in memory!',
    'tip_learn_daily': 'Tip: Focus on learning 5-10 new words per day for best results!',
    'start_streak_today': 'Start your streak today!',
    'profile': 'Profile',
    'share_with_friends': 'Share with Friends',
    'share_description': 'Help your friends prepare for Cyprus exams too!',
    'share_app': 'Share App',
    'share_message': 'Check out this awesome app for Cyprus exam preparation! 🇨🇾',
    'tap_to_copy': 'Tap to copy',
    'member_since': 'Member since',
    // Profile membership card (features/Profile/MembershipCard.tsx)
    'membership_adept_title': 'Hallouminati Adept',
    'membership_adept_since': 'Since :date',
    'membership_free_title': 'Free version',
    'membership_free_body': 'Adepts get access to all materials.',
    'membership_free_cta': 'Become an Adept',
    'learning_streak': 'Learning Streak',
    'first_day_streak': 'First day of your learning journey!',
    'days_streak_message': ':days days of consistent learning!',
    'support_us': 'Support Us',
    'support_description': 'Help us keep the app free and improve it with new features!',
    'buy_me_coffee': 'Buy Me a Coffee',
    'revolut_support': 'Donate via Revolut',
    'settings': 'Settings',
    'app_language': 'App Language',
    'quiz_language': 'Quiz Language',
    'quiz_language_description': 'Exam simulations always start in Greek',
    'quiz_language_update_failed': 'Could not save quiz language. Please try again.',
    'study_reminders': 'Study Reminders',
    'reminders_description': 'Get notifications to keep learning',
    'notifications_blocked_banner': 'Notifications are blocked in device settings. Tap to enable.',
    'notifications_denied_error': 'Notifications are blocked. Enable them in device settings to receive reminders.',
    'open_settings': 'Open Settings',
    'settings_updated': 'Settings updated successfully',
    'haptic_feedback': 'Haptic Feedback',
    'haptic_feedback_description': 'Vibrate on taps and answers',
    'autoplay_audio': 'Auto-play audio',
    'appearance': 'Appearance',
    'appearance_system': 'Auto',
    'appearance_light': 'Light',
    'appearance_dark': 'Dark',
    'never': 'Never',
    'daily': 'Daily',
    'hourly': 'Hourly',
    'weekly': 'Weekly',
    'help_support': 'Help & Support',
    'still_need_help': 'Still need help?',
    'contact_support': 'Contact Us',
    'rate_us': 'Rate us on the App Store',
    'rate_us_desc': 'Enjoying the app? A quick rating helps others find us',
    'rate_us_btn': 'Leave a review',
    'made_with_love': 'Made with ❤️ in Cyprus',
    'about_exam': 'About the exam',
    'about_exam_btn': 'What is the exam and how to pass it?',
    'memory_check_title': 'Do you remember this word?',
    'memory_check_yes': '✅ Yes, I remember',
    'memory_check_no': '❌ No, I forgot',
    'memory_check_success': "🎉 *Great memory!*\n\n`:word` → :translation\n\n_Keep up the excellent work!_",
    'memory_check_forgot': "📚 *No worries!*\n\nHere's the meaning:\n\n`:word` → :translation\n\n_We'll practice this word more often._",
    'quiz_title': '🎯 *Quick Quiz*',
    'vocab_quiz_question': "How would you say *:translation* in Greek?\n\n_Choose the correct answer:_",
    'exam_quiz_question': "What is the correct answer?\n\n*:question*\n\n_Choose the correct answer:_",
    'quiz_correct': "✅ *Correct!*\n\n`:answer`\n\n_Well done! Keep practicing._",
    'quiz_incorrect': "❌ *Not quite right*\n\nThe correct answer is:\n\n`:answer`\n\n_Try again!_",
    'practice_button': "📱 Let's practice",
    'practice_more_button': '🎮 Practice More',
    'practice_mode_button': '📱 Practice Mode',
    'try_another_button': 'Try Another',
    'memory_check_button': '🔄 Another Memory Check',
    'send_more_vocab': '🔄 Another Word',
    'send_more_exam': '🔄 Another Question',
    'send_more_any': '🔄 Send More',
    'unsubscribe_button': '🔕 Turn off notifications',
    'reminder_offer_title': 'Remind you to practise tomorrow?',
    'reminder_offer_subtitle': 'One notification a day, at this time. Turn it off in your profile whenever.',
    'reminder_turn_on': 'Remind me',
    'not_now': 'Not now',
    'reminder_enabled_message': 'Reminders enabled! You can change this in settings.',
    'reminder_disabled_message': 'No worries. You can enable reminders later in settings.',
    'exam_passed': 'Exam passed!',
    'exam_late_fade': 'Noticeably more mistakes in the last third of the exam than in the first.',
    'exam_language_warning': 'You answered some questions outside Greek. The real exam is in Greek only.',
    'review_in_guide_title': 'What to review in the guide',
    'loading': 'Loading',
    'did_you_know': 'Did you know?',
    'means': 'means',
    'session_load_error': 'Unable to load practice session. Please check your connection and try again.',
    'session_load_error_default': 'Something went wrong while loading your practice session.',
    'try_again': 'Try Again',
    'retrying': 'Retrying',
    'practice_by_level': 'Practice by Level',
    'practice_by_level_description': 'Choose a level to practice specific word groups',
    'level': 'Level',
    'practice_by_word_type': 'Practice by Word Type',
    'practice_by_word_type_description': 'Focus on specific word categories',
    'verbs': 'Verbs',
    'adjectives': 'Adjectives',
    'adverbs': 'Adverbs',
    'prepositions': 'Prepositions',
    'nouns': 'Nouns',
    'pronouns': 'Pronouns',
    'numerals': 'Numerals',
    'phrases': 'Phrases',
    'practicing': 'Practicing',
    'filtered_by_word_class': 'Showing only words from this category',
    'chapter_not_found': 'Chapter not found',
    'guide_title_part1': 'Cyprus Essentials',
    'guide_title_part2': ' A–Z',
    'app_title_hallouminati': 'Hallouminati Academy',
    'xp_needed': 'XP needed',
    'words_learned_today': 'Words learned today',
    'learning': 'Learning',
    'learned': 'Learned',
    'mastered': 'Mastered',
    'total_words': 'Total Words',
    'progress_words': ':current of :target words',
    'streak': 'Streak',
    'select_frequency': 'Select frequency',
    'notification_prompt_message_1': 'Ready to crush your goals today?',
    'notification_prompt_message_2': 'Consistency is key! 🗝️ Let\'s practice together daily.',
    'notification_prompt_message_3': 'Don\'t let your streak cool down! 🔥 Turn on reminders.',
    'turn_on_notifications': 'YES, REMIND ME',
    'matches': 'matches',
    'good_remember': 'Great! Keep it up!',
    'word_graduated_to_review': 'Excellent! This word has graduated to review!',
    'good_start_learning': 'Good start! Keep practicing this word.',
    'dont_worry_will_practice_more': 'Don\'t worry! We\'ll practice this word more often.',
    'dont_worry_will_return': 'Don\'t worry! This word will come back for review.',
    'correct_match': 'Correct match!',
    'incorrect_match': 'Not quite right, try again.',
    'correct_choice': 'Correct!',
    'incorrect_choice': 'Incorrect',
    'word_marked_learned': 'Word marked as learned!',
    'word_reset': 'Word has been reset.',
    'logout_confirm': 'Are you sure you want to log out?',
    'logging_out': 'Logging out...',
    'reset_progress': 'Reset Progress',
    'reset_progress_description': 'Clear all your learning data and start fresh',
    'reset_progress_title': 'Reset All Progress?',
    'reset_progress_warning': 'This will permanently delete all your learning progress, including mastered words, practice history, and streaks. This action cannot be undone.',
    'reset_progress_confirm_btn': 'Reset Everything',
    'resetting_progress': 'Resetting...',
    'reset_progress_success': 'Your progress has been reset successfully',
    'reset_progress_error': 'Failed to reset progress. Please try again.',
    'reset': 'Reset',

    'guide_read_progress': 'Completed',
    'guide_welcome_title': 'Master the Cyprus\nCulture & Politics Exam',
    'guide_welcome_subtitle': 'Direct. Current. Exam-Focused.',
    'guide_welcome_intro_bold': 'Welcome to Cyprus Culture & Politics Guide.',
    'guide_welcome_intro_text': 'We know your goal: passing the exam efficiently. We have analyzed years of previous exam questions to filter out the noise and keep only what matters.',
    'guide_welcome_why_different': 'Why this guide is different:',
    'guide_welcome_point1_title': 'Zero Fluff:',
    'guide_welcome_point1_text': 'No long lectures. We provide only the high-yield facts, dates, and names you need to score points.',
    'guide_welcome_point2_title': 'Exam-Based Logic:',
    'guide_welcome_point2_text': 'Every chapter is structured around topics that frequently appear on the actual test.',
    'guide_welcome_point3_title': 'Always Current:',
    'guide_welcome_point3_text': 'Policies change. Our guide is regularly updated with the latest cabinet ministers, economic thresholds, and political events.',
    'guide_welcome_quote': 'From the heights of Mount Olympus to the latest Parliamentary data, everything you need is right here.',
    'guide_welcome_start_button': 'Start Learning',


    // FAQ Section
    'faq_q1': 'How does the app work?',
    'faq_a1': 'Our app helps you prepare for Cyprus Culture exam through daily practical exercises. Answer questions and study vocabulary to improve your results and keep your learning streak going.',
    'faq_q2': 'Can I learn everything for the exam using only this app?',
    'faq_a2': 'Yes, if you can read Greek.<br />We recommend studying every day: first answer questions in your native language, then gradually switch to Greek. At the same time, practice words in the "Vocabulary" section at your own comfortable pace.<br />Closer to the exam date, we suggest taking full tests in Greek in the "Exams" section.<br /><br />According to recent user survey (may 2026), 82% of those who used Hallouminati passed the exam on their first try.',
    'faq_q3': 'How much time is needed to prepare?',
    'faq_a3': 'We know people who started at level A0 (could only read and knew a few words) — after one month of daily practice, they prepared well and passed the exam successfully.<br />It all depends on your motivation and consistency.',
    'faq_q4': 'Where do the questions come from? Are these official materials?',
    'faq_a4': 'We collected tasks from past exams that were publicly available.<br />We also created our own questions based on information from the official tourism portal visitcyprus.com and news sites like cyprus-mail.com.<br />The wording may differ from the official one, but the topics and level match.',
    'faq_q5': 'Why is the app free?',
    'faq_a5': 'We made the app for ourselves and friends to prepare for the exam.<br />Now we want it to help as many people as possible pass the exam on Cyprus culture.<br /><br />If you want to support the project, you can send a donation in the "Support" section.',
    'faq_q6': 'Who made this app?',
    'faq_a6': 'Leonid Zhavoronkov — <a class="text-link" href="https://t.me/zhavoronkov">t.me/zhavoronkov</a>',
    'faq_q7': 'How often do you update the questions?',
    'faq_a7': 'We add new questions immediately after official exams become publicly available — usually on exam day.<br />Also, 1–2 months before the exam, we upload 30–40 fresh tasks based on the latest news and events in Cyprus.',
    'faq_q12': 'There are over 1,000 questions. Do I need to learn them all?',
    'faq_a12': 'No. Questions are not mixed at random — they come in order of importance, so you see what matters most first:<br />1) First, questions from past exams and key facts.<br />2) Then the other important topics.<br />3) Rare facts only once you have covered ~70% of the core questions in a topic. A practice exam has at most 3 of them per 25.<br /><br />Harder versions ("which is NOT true", "fill in the blank") appear only after you have answered the original question correctly.<br />Questions you get wrong come back more often, and past-exam questions repeat more often than the rest.',
    'faq_q8': 'How do you choose words for the vocabulary?',
    'faq_a8': 'We took all the words from the question database and sorted them by frequency.<br />This forms the vocabulary.<br />For practice, we use an SRS (spaced repetition) system: it decides which words you need to review and when, to help you remember better.',
    'faq_q11': 'How does a word get marked as "learned"?',
    'faq_a11': 'A word isn\'t marked "learned" from a single correct answer — we use a spaced repetition system (SRS). Each word moves through several review steps with growing gaps (2 hours → 8 hours → 1 day → 3 days → 7 days): a correct answer pushes it forward, a mistake sends it back.<br />A word becomes "learned" only once you answer it correctly consistently — for example, after passing all the steps, or showing a high success rate (around 80%+) over enough attempts.<br />Harder exercises (typing the full translation) advance a word faster than easy ones (multiple choice or matching pairs). And if you later forget a word you\'d already learned, it can drop back into review.',
    'faq_q10': 'How can I reset my progress in the app?',
    'faq_a10': 'Go to your Profile page, scroll down to Settings, and tap the "Reset" button next to "Reset Progress". This will clear all your learning data and allow you to start fresh.',
    'faq_q99': 'Do you have a similar app for those preparing for a language exam?',
    'faq_a99': 'Yes! We built a GreekBrain mini-app just for that — give it a try here: <a href="https://t.me/greekbrain_bot" class="text-link">t.me/greekbrain_bot</a>',

    // Cyprus Guide
    'exam_guide': 'Exam Guide',
    'latest_update': 'Latest Update',
    'recent_updates': 'Recent Updates',
    'no_recent_updates': 'No recent updates available.',
    'loading_guide_content': 'Loading guide content...',
    'failed_to_load_guide': 'Failed to load guide',
    'tap_to_retry': 'Tap to Retry',
    'completed': 'Completed',
    'view_chapter': 'View Chapter',
    'guide_pdf_download': 'Download the guide as PDF',
    'guide_pdf_download_free': 'Download the free PDF',
    'guide_pdf_preparing': 'Preparing your personal copy…',
    'guide_pdf_open': 'Open the PDF',
    'guide_pdf_failed': 'Could not prepare the PDF. Try again later.',
    'chapters': 'Chapters',
    'more': 'more',
    'pro': 'PRO',
    'min_read': 'min read',
    'chapter': 'Chapter',
    'lifetime_access': 'Lifetime Access',
    'processing': 'Processing...',
    'loading_chapter': 'Loading chapter...',
    'no_content_available': 'No content available for this chapter.',
    'chapter_load_failed': 'We couldn\'t load this chapter. It may be a connection issue — please try again.',
    'chapter_not_downloaded': 'You\'re offline and this chapter hasn\'t been downloaded yet. Reconnect to read it.',
    'no_internet_title': 'No internet connection',
    'guide_offline_uncached': 'Connect to the internet once to download the guide — it\'ll be available offline after that.',
    'guide_saved_offline': 'Available offline',
    'guide_saving_offline': 'Saving for offline',
    'guide_downloaded_offline': 'downloaded for offline',
    'guide_offline_ready_desc': 'All chapters are downloaded — you can read the guide without internet.',
    'guide_offline_saving_desc': 'Chapters are downloading so you can read the guide offline.',
    'guide_offline_partial_desc': 'Reconnect to the internet to finish downloading the guide.',
    'chapter_complete': 'Chapter Complete!',
    'great_job_mastering': 'Great job mastering this topic.',
    'next_chapter': 'Next Chapter',
    'keep_reading': 'Keep reading',

    // Topic Mastery Guide Link
    'study_in_guide': 'Study in Guide',

    // Report Issue
    'found_mistake': 'Found a mistake?',
    'report_issue_description': 'Thanks for helping us improve! Please describe what\'s wrong or missing.',
    'report_issue_placeholder': 'e.g., The date in the second paragraph is incorrect...',
    'send_report': 'Send Report',
    'sending_report': 'Sending...',
    'report_sent_success': 'Thanks! We\'ll look into it.',
    'report_issue_min_length': 'Please provide at least 10 characters',

    // Paywall
    'paywall_title_default': 'Hallouminati Adepts receive:',
    'paywall_subtitle_default': 'Everything you need to prepare for the culture exam',
    'paywall_benefit_1': 'Cyprus guide: 40+ chapters on the island’s history, culture, finances and current affairs',
    'paywall_benefit_2': 'Question bank with 1,200+ questions',
    'paywall_benefit_3': 'Geography quiz with an interactive map',
    'paywall_benefit_4': 'Greek trainer with 2,400+ words from exam questions',
    'paywall_benefit_5': 'Cyprus government officials trainer',
    'paywall_guide_title': 'The complete guide and everything you need to prepare',
    'paywall_content_updated': 'Updated Oct 2026',
    'paywall_content_updated_short': 'Oct 2026',
    'paywall_social_count': '11,000+',
    'paywall_social_label': 'people passed\nwith us',
    'paywall_pass_rate': '82%',
    'paywall_pass_rate_label': 'pass on the\nfirst try',
    'paywall_cta_price': 'One-time payment',
    'paywall_cta_button': 'Unlock Full Access',
    'one_time_payment': 'One-time payment',
    'paywall_guide_context_title': 'Join Hallouminati Adept',
    'paywall_guide_context_subtitle': 'This chapter is available exclusively for Hallouminati Adepts.',
    'premium_content_locked': 'Premium Content',
    'unlock_full_chapter': 'Unlock to continue reading',
    'sign_in': 'Sign In',
    'sign_in_required': 'Sign In Required',
    'sign_in_to_unlock': 'Sign in to access this chapter',
    'auth_required_message': 'Sign in to your account to access exams, practice sessions, and all features of the app.',
    'exam_registration_date': 'Registration to the exam would be opened on 16 of December',
    'correct_order': 'Correct order',
    'special_offer_onboarding': 'Special Offer',
    'special_offer_limited': 'Limited Time',
    'offer_expires_in': 'Expires in:',
    'paywall_no_recurring': 'One-time payment. No recurring fees.',
    'paywall_loading': 'Loading your offer…',
    'paywall_load_failed': 'Couldn’t load pricing. Please check your connection and try again.',
    'paywall_retry': 'Try Again',
    'purchase_success': 'Purchase successful! Welcome to Hallouminati Adepts.',
    'purchase_failed': 'Purchase failed. Please try again.',
    'restore_purchases': 'Restore Purchases',
    'purchases_restored': 'Your purchase has been restored!',
    'restore_failed': 'No purchases found to restore.',
    'terms_of_use': 'Terms of Use',
    'privacy_policy': 'Privacy Policy',

    // Payment success / Adept welcome screen
    'payment_processing_title': 'Processing payment…',
    'payment_processing_subtitle': 'Confirming your Adept status, just a moment…',
    'payment_processing_attempt': 'Attempt :current of :max',
    'adept_welcome_title': 'You are now a Hallouminati Adept!',
    'adept_welcome_subtitle': 'Congratulations — lifetime access to the full guide, all questions and the exam vocabulary is yours.',

    // Refer-a-friend discount
    'referral_paywall_perk_title': 'Refer a friend',
    'referral_paywall_perk_text': 'After purchase you\'ll get a :percent% discount code to share with a friend — valid for :days days.',
    'referral_have_code': 'Have a discount code?',
    'referral_apply': 'Apply',
    'referral_code_applied_title': ':percent% discount applied',
    'referral_code_remove': 'Remove',
    'referral_code_invalid': 'This code is invalid or has expired.',
    'referral_code_unavailable': 'Discount codes are temporarily unavailable. Please try again later.',
    'referral_discount_applied': 'Friend Discount',
    'referral_banner_title': 'Gift a friend :percent% off',
    'referral_banner_info_title': 'How a friend gets the discount',
    'referral_banner_info_text': 'Before paying, they tap "Have a discount code?" above the "Unlock Full Access" button and enter your code — the price drops by :percent% right away.',
    'referral_banner_info_reuse': 'Several friends can use it until it expires.',
    'referral_copy': 'Copy',
    'referral_share': 'Share',
    'referral_code_copied': 'Code copied!',
    'referral_expires_in': 'Expires in :time',
    'referral_ticket_title': 'Give it to a friend',
    'referral_time_left': ':time left',
    'duration_days_hours': ':daysd :hoursh',
    'duration_hours_minutes': ':hoursh :minutesm',
    'duration_minutes': ':minutesm',
    'referral_share_text': 'Get :percent% off Hallouminati — the app for the Cyprus history & culture exam. Before paying, tap "Have a discount code?" and enter my code :code',

    // Telegram community banner in the profile and the caption under it: one line each
    'community_invite_title': 'Got questions?',
    'community_invite_meta': 'Get help in our chat',
    'community_invite_join': 'Ask',
    'community_invite_caption': 'Exam dates, registration, preparation. In Russian',
    'community_invite_hide': 'Hide',

    // Word stats labels
    'stat_accuracy': ':value% acc',
    'stat_correct_attempts': ':correct of :total correct',
    'stat_learned_at': 'learned :time',
    'stat_last_practice': 'last :time',

    // AI Tutor
    'ai_tutor': 'AI Tutor',
    'tutor_subtitle': 'Your personal Greek language assistant',
    'new_chat': 'Start New Chat',
    'new_chat_description': 'Begin a new conversation with your AI tutor',
    'voice_chat': 'Voice Chat',
    'voice_chat_desc': 'Speak and listen in Greek',
    'exercises': 'Exercises',
    'exercises_desc': 'Interactive practice cards',
    'recent_chats': 'Recent Chats',
    'no_chats_yet': 'No conversations yet',
    'start_learning': 'Start your first lesson with the AI tutor!',
    'type_message': 'Type a message...',
    'listening': 'Listening...',

    // AI Tutor - Topics & Quiz
    'quick_quiz': 'Quick Quiz',
    'quick_quiz_desc': 'Test your knowledge with 10 questions',
    'start_quiz': 'Start Quiz',
    'quiz_focus_prompt': 'What would you like to practice?',
    'ai_decide': 'Let AI Decide',
    'ai_decide_desc': 'Based on your weak areas and progress',
    'specific_topic': 'Specific Topic',
    'specific_topic_desc': 'Choose a skill area to focus on',
    'select_skill_area': 'Select Skill Area',
    'tap_to_start': 'Tap to start quiz',
    'not_practiced': 'New',
    'error_loading_skills': 'Failed to load skills',
    'skill_area_grammar': 'Grammar',
    'skill_area_grammar_desc': 'Articles, verbs, cases, and more',
    'skill_area_vocabulary': 'Vocabulary',
    'skill_area_vocabulary_desc': 'Words, phrases, and expressions',
    'skill_area_communication': 'Communication',
    'skill_area_communication_desc': 'Practical conversations',
    'generating_quiz': 'Generating Quiz...',
    'ai_preparing_questions': 'AI is preparing questions for you',
    'speaking_topics': 'Speaking Topics',
    'dialogue_history': 'History',
    'no_dialogues_yet': 'No sessions yet',
    'start_first_dialogue': 'Start your first conversation or quiz!',
    'load_more': 'Load more',
    'error_loading_topics': 'Failed to load topics',
    'no_topics_available': 'No topics available yet',

    // AI Tutor - Topic Selection
    'select_level': 'Select difficulty level',
    'error_loading_topic': 'Failed to load topic',
    'choose_scenario': 'Choose your scenario',
    'your_progress': 'Your Progress',

    // AI Tutor - Dialogue
    'speaking_practice': 'Speaking Practice',
    'type_in_greek': 'Type in Greek...',
    'end_conversation': 'Finish',
    'abandon_dialogue': 'Leave Without Saving',
    'back_to_topics': 'Back to Topics',
    'dialogue_completed': 'This conversation has ended',
    'error_loading_dialogue': 'Failed to load conversation',
    'starting_dialogue': 'Starting...',
    'scenario': 'Scenario',
    'finish_dialogue': 'Finish Dialogue',
    'finish_and_review': 'Finish',
    'preparing_review': 'Preparing your review...',

    // AI Tutor - Quiz
    'starting_quiz': 'Starting...',
    'error_loading_quiz': 'Failed to load quiz',
    'exit_quiz_title': 'Leave Quiz?',
    'exit_quiz_message': 'Your progress will not be saved if you leave now.',
    'leave': 'Leave',
    'type_answer': 'Type your answer...',
    'quiz_completed': 'Quiz completed!',

    // AI Tutor - Scores & Feedback
    'grammar_score': 'Grammar',
    'vocabulary_score': 'Vocabulary',
    'communication_score': 'Communication',
    'strengths': 'Strengths',
    'areas_to_improve': 'Areas to Improve',
    'overall_feedback': 'Overall Feedback',
    'practice_again': 'Practice Again',
    'try_another_quiz': 'Try Another Quiz',

    // Correction Phase (DuoLingo-style)
    'correction_phase_title': "Let's fix your mistakes!",
    'correction_phase_subtitle': 'Practice the exercises you missed until you get them right.',
    'exercise_to_correct': 'exercise to correct',
    'exercises_to_correct': 'exercises to correct',
    'lets_go': "Let's Go!",
    'correction_phase_label': 'Correction Round',

    // AI Tutor - Exercise & Quiz Cards
    'type_your_answer': 'Type your answer...',
    'type_translation': 'Type the translation...',
    'fill_in_blank': 'Fill in the blank...',
    'submit': 'Submit',
    'excellent_correct': "Excellent! That's correct!",
    'keep_practicing_next_time': "Keep practicing! You'll get it next time.",
    'not_quite': 'Not quite',
    'explanation': 'Explanation',

    // AI Tutor - Quiz Summary
    'quiz_complete': 'Quiz Complete!',
    'wrong': 'wrong',
    'questions_label': 'Questions',
    'time_label': 'Time',
    'areas_tested': 'Areas Tested',
    'focus_on': 'Focus On',
    'quiz_cost': 'Quiz cost',

    // AI Tutor - Feedback Summary
    'conversation_complete': 'Conversation Complete!',
    'exchanges_in_session': 'exchanges in this session',
    'your_scores': 'Your Scores',
    'average': 'average',
    'session_cost': 'Session cost',

    // AI Tutor - Topic Card & Message Bubble
    'never_practiced': 'Never practiced',
    'just_now': 'Just now',
    'minutes_ago': ':count min ago',
    'hours_ago': ':count hr ago',
    'days_ago': ':count days ago',
    'weeks_ago': ':count weeks ago',
    'months_ago': ':count months ago',
    'avg_score': 'Avg',
    'start_session': 'Start',
    'stop': 'Stop',
    'listen': 'Listen',
    'room_to_grow': 'Room to grow!',
    'good_work': 'Good work!',

    // GreekBrain Practice
    'practice_title': 'Practice',
    'practice_subtitle': 'Build your Greek skills step by step',
    'practice_ready_continue': 'Ready to continue?',
    'practice_pick_up': 'Pick up where you left off',
    'practice_resume_learning': 'Resume Learning',
    'practice_failed_load': 'Failed to load chapters',
    'practice_retry': 'Retry',
    'practice_no_chapters': 'No chapters available',
    'practice_check_back': 'Check back soon for new content',
    'practice_skill_done': 'Done',
    'skill_vocabulary': 'Vocabulary',
    'skill_grammar': 'Grammar',
    'skill_communication': 'Communication',

    // Community Group
    'join_community': 'Join Community',
    'join_community_cta': 'Join our Telegram group',

    // Study Progress Widget
    'empty_readiness_message': 'Answer your first questions to see your exam forecast here.',
    // Mobile App Banner (App Store / Google Play)
    'ios_app_banner_title': 'Download Hallouminati for iPhone',
    'ios_app_banner_subtitle': 'Practice reminders, and it opens from your home screen.',
    'ios_app_banner_cta': 'Download on the App Store',
    'android_app_banner_title': 'Download Hallouminati for Android',
    'android_app_banner_subtitle': 'Practice reminders, and it opens from your home screen.',
    'android_app_banner_cta': 'Get it on Google Play',
    'app_banner_cta_short_ios': 'App Store',
    'app_banner_cta_short_android': 'Google Play',
    'desktop_app_banner_label': 'Also available on iPhone and Android',

    // Onboarding (Android — ported from the native iOS onboarding)
    'onboarding_next': 'Next',
    'onboarding_start': 'Start preparing',
    'onboarding_login': 'Log in',
    'onboarding_hook_headline': 'Everything you need to pass the Cyprus culture exam',
    'onboarding_hook_subtitle': 'Questions, vocabulary, guide — all in one app. No more scattered PDFs and outdated materials.',
    'onboarding_hook_badge_learners': 'people preparing',
    'onboarding_hook_badge_pass': 'pass on first try',
    'onboarding_hook_badge_questions': 'exam questions',
    'onboarding_practice_headline': '1,200+ questions based on real exams',
    'onboarding_practice_subtitle': 'Practice in your language, then switch to Greek. The app will show your weak topics.',
    'onboarding_vocab_headline': '2,400+ words from the exam questions, most frequent first',
    'onboarding_vocab_subtitle': 'Smart repetition — the app decides which word to review and when.',
    'onboarding_guide_headline': 'Cyprus Guide — 40+ chapters from the Neolithic to today\'s government',
    'onboarding_guide_subtitle': 'All information that appears on the exam — collected, structured, and regularly updated.',
    'onboarding_guide_tag_history': 'History',
    'onboarding_guide_tag_politics': 'Politics',
    'onboarding_guide_tag_culture': 'Culture',
    'onboarding_guide_tag_geography': 'Geography',
    'onboarding_guide_tag_economy': 'Economy',

    // ── Setup flow ─────────────────────────────────────────────────────────
    // One flow, two surfaces: the one-question card on Profile and the
    // full-screen wizard. Both read these strings — the card renders the title
    // and the options, the wizard also renders the body.
    //
    // Rewritten 2026-08-21 against docs/design/voice-and-tone.md §9 row 1. The
    // shortening pass that produced the shipped version had removed the
    // *reasons*, not the words, which is why the flow read as a survey. Rules
    // applied here: a question is a complete question with its verb (§5); an
    // option reads on its own, without the title above it (§5); any screen
    // that asks for something says in one clause what the user gets (§4.2);
    // sentence case, no amplifier emoji, numbers instead of adjectives (§6).
    'setup_yes': 'Yes',
    'setup_step_of': 'Step :current of :total',
    'setup_back': 'Back',
    'setup_wizard_skip': 'Skip for now',
    'setup_saved': 'Noted — thanks.',

    // Step 0 — whose app this is, which exam we mean, what the minute buys.
    'setup_welcome_title': 'Everything you need to pass the Cyprus exam',
    'setup_welcome_body': 'No scattered PDFs, no outdated lists — one app, kept current.',
    'setup_welcome_cta': 'Get started',
    'setup_welcome_skip': 'Not now',

    // Goal — why they are here, asked once and used to route the rest.
    'setup_goal_title': 'What brings you here?',
    'setup_goal_body': 'It decides which dates and reminders we set up.',
    'setup_goal_exam': 'I need to pass the culture exam',
    'setup_goal_curious': 'Just curious about Cyprus — no exam',

    // Step 1 — language
    'setup_lang_title': 'Which language should the app use?',
    'setup_lang_body': 'Questions, the guide and every reminder follow this.',

    // Step 2 — the culture exam: the one date the whole app counts down to.
    'setup_culture_title': 'When are you sitting the culture exam?',
    'setup_culture_body': 'We’ll count down to it and flag when registration opens.',
    'setup_culture_passed': 'I’ve already passed the exam',
    'setup_culture_undecided': 'I haven’t decided yet',
    // Only when the screen stands alone (Profile, the launch ask) — see CULTURE_NOT_SITTING.
    'setup_culture_not_sitting': 'I’m not taking the exam',
    'setup_culture_signup_opens': 'Registration opens :date',
    'setup_culture_signup_until': 'Registration until :date',
    'setup_culture_signup_closed': 'Registration has closed',

    // Step 3 — reminders
    'setup_reminders_title': 'How often should we remind you?',
    'setup_reminders_body': 'A nudge to practise, plus one before the exam. Change it any time.',
    'setup_reminders_daily': 'Every day',
    'setup_reminders_weekly': 'Once a week',
    'setup_reminders_never': 'No reminders',

    // Step 4 — the Greek exam. Q1 carries the framing for the whole block, so
    // the follow-ups stay bare: by then the user has opted into the
    // conversation and a reason on every screen reads as pleading.
    'setup_q1_title': 'Are you taking the Greek language exam too?',
    'setup_q1_sub': 'We’ll show you the next sittings and when registration opens.',
    'setup_q1_passed': 'I already have a certificate',
    'setup_q1_not_yet': 'Not yet — I still need it',
    'setup_q1_not_needed': 'I don’t need it',

    'setup_q2_title': 'Which Greek level do you need?',
    'setup_q2_caption': 'It depends on your route and how long you’ve been here — your lawyer will know exactly.',
    'setup_q2_other': 'Something else',
    'setup_q2_unknown': 'I don’t know yet',

    'setup_q2b_title': 'Which Greek level do you have?',
    'setup_q2b_b2plus': 'B2 or higher',
    'setup_q2c_title': 'Will you need a higher Greek level later?',
    'setup_q2c_no': 'No, that’s all I need',

    'setup_q3_title': 'Are you studying Greek at the moment?',
    'setup_q3_teacher': 'Yes — with a teacher or a course',
    'setup_q3_self': 'Yes — on my own',
    'setup_q3_soon': 'Not yet, planning to',
    'setup_q3_no': 'No',

    'setup_q4_title': 'When are you sitting the Greek exam?',
    'setup_q4_sub': 'Pick a sitting and we’ll remind you before registration closes.',
    'setup_q4_later': 'Later than that',
    'setup_q4_unknown': 'I don’t know yet',

    // ── The closing screen: their exam, one way in, and how to prepare ────
    'setup_done_title': 'You’re all set',
    'setup_done_sub_curious': 'No exam, then — just Cyprus, at your own pace.',
    'setup_done_sub_not_needed': 'No Greek exam, then — we won’t bring it up again.',
    'setup_done_sub_passed': 'Greek certificate done — we’ll only check back if you go for a higher level.',
    'setup_done_sub_culture_passed': 'Nothing left to sit. The Greek exam is the one that might still be ahead.',
    'setup_done_cta': 'Open Hallouminati',

    'setup_exam_card_name': 'Cyprus history & culture exam',
    'setup_exam_card_facts': '25 questions · 60% to pass',
    'setup_exam_card_signup': 'Registration opens :date — we’ll remind you',
    'setup_exam_days_one': ':count day to prepare',
    'setup_exam_days_few': ':count days to prepare',
    'setup_exam_days_many': ':count days to prepare',
    'setup_greek_watch': 'Greek: :value — we’ll let you know when registration opens.',
    'setup_greek_remind': 'Greek: :value — we’ll remind you before the exam.',

    'setup_start_title': 'Start with 10 questions',
    'setup_start_body': 'Your first practice is on the home tab — three minutes, and you’ll see which topics need the work.',
    'setup_start_body_curious': 'Your first practice is on the home tab — 10 questions about Cyprus, three minutes.',
    'setup_test_foot': '82% of people who prepare with Hallouminati pass on their first try.',

    'setup_plan_title': 'How to prepare for it',
    'setup_plan_1_title': 'Practise ten minutes a day',
    'setup_plan_1_desc': 'Hallouminati picks the questions from your weak topics.',
    'setup_plan_2_title': 'Start in English, move to Greek',
    'setup_plan_2_desc': 'The exam is in Greek, and a question only counts as learned once you answer it in Greek.',
    'setup_plan_3_title': 'The 500 exam words',
    'setup_plan_3_desc': 'The wording in recent papers got harder — even B1 is not always enough to follow the question.',
    'setup_plan_4_title': 'Read up on weak topics in the guide',
    'setup_plan_4_desc': '40+ chapters: history, politics, culture, the map and the officials.',
    'setup_plan_5_title': 'A week before: the timed mock',
    'setup_plan_5_desc': '25 questions, exam conditions.',

    'setup_plan_title_curious': 'What’s in Hallouminati',
    'setup_curious_1_title': '1,200+ questions from real papers',
    'setup_curious_1_desc': 'Ten-minute sessions; Hallouminati picks the topics.',
    'setup_curious_2_title': 'Cyprus Guide',
    'setup_curious_2_desc': '40+ chapters: history, politics, culture, the map and the officials.',
    'setup_curious_3_title': '2,400+ words from the exam questions',
    'setup_curious_3_desc': 'The same words the papers use, with translations.',

    // ── Existing users: re-asserting an answer, and the result afterwards ───
    'setup_confirm_body': 'So your reminders and dates stay accurate.',
    'setup_confirm_yes': 'Yes',
    'setup_confirm_changed': 'Something’s changed',
    'setup_confirm_thanks': 'Thanks — noted.',

    // ── Profile › Your exams: the answers on file, and the way to change them ──
    'profile_exams': 'Your exams',
    // The heading already says "exams", so the rows don't repeat it.
    'profile_exam_culture': 'Culture',
    'profile_exam_greek': 'Greek',
    'profile_exam_passed': 'Passed',
    'profile_exam_not_sitting': 'Not taking it',
    'profile_exam_not_needed': 'Not needed',
    'profile_exam_undecided': 'Date not chosen',
    'profile_exam_preparing': 'Preparing',
    'profile_exam_add': 'Add',

    'setup_result_culture_title': 'How did it go?',
    'setup_result_culture_body': 'Would you tell us how you did? It helps us a lot.',
    'setup_result_greek_title': 'And the Greek exam — how did that go?',
    'setup_result_greek_body': 'Last one, promise.',
    'setup_result_passed_60': 'I got 60% or more',
    'setup_result_50_60': 'Between 50% and 60%',
    'setup_result_passed': 'I passed',
    'setup_result_failed': 'I didn’t pass',
    'setup_result_skipped': 'I didn’t sit it',
    'setup_result_congrats': 'Congratulations! That’s the hard one done.',
    'setup_result_noted': 'Thanks — noted.',

    // The headline for whichever screen the survey opens on, once the ministry
    // has published. Somebody arriving from the "results are out" push must see
    // the results, not a bare question about them.
    'setup_result_ready_title': 'Your exam results are out 🇨🇾',
    'setup_result_ready_body': 'The official {month} results are linked below.',
    // Sits BELOW the link: the thing they came for first, the ask second.
    'setup_result_share_prompt': 'Share your result with us',
    'setup_result_pdf_link': 'Open the official results',
    'setup_result_not_sat': 'I didn’t sit it in {month}',

    // Which sitting were you in? Only asked when one exam day ran two of them
    // with a different paper in each — July 2026 did, at 09:00 and 11:00.
    'setup_result_sitting_title': 'Which sitting did you take?',
    'setup_result_sitting_at': 'The {time} sitting',

    // Asked after anything that was not a pass. Not a date — at this point
    // there is rarely a next sitting announced.
    'setup_next_exam_title': 'Will you sit the next one?',
    'setup_next_exam_yes': 'Yes, I’ll sit it',
    'setup_next_exam_unsure': 'Haven’t decided yet',
    'setup_next_exam_no': 'No, I’m done with it',
    'setup_next_exam_thanks': 'Thanks. We’ll write when the dates are announced.',

    // A pass, on a native build only. The one moment asking for a review is
    // not an interruption.
    'setup_review_title': 'Congratulations on passing!',
    'setup_review_body': 'If Hallouminati helped — leave a review. It takes a couple of minutes, and reviews are how people find us.',
    'setup_review_cta': 'Leave a review',
    'setup_review_later': 'Not now',

    'setup_replay_title': 'Replay onboarding',
    'setup_replay_desc': 'Run the whole flow again from the first screen',

    // Gifts — docs/hallouminati/gift-codes.md
    'back': 'Back',
    'gift_row_title': 'Gift Hallouminati',
    'gift_buy_title': 'Adept as a gift',
    'gift_buy_cta': 'Buy for :price',
    'gift_sale_until': '−:percent% until :date',
    'gift_quantity_label': 'Number of gifts',
    'gift_purchase_waiting': 'Wrapping your gifts…',
    'gift_purchase_pending': 'Payment received — your gifts will appear here in a minute.',
    'gift_your_gifts': 'Your gifts',
    'gift_opened_on': 'Opened :date',
    'gift_send': 'Send',
    'gift_copy_link': 'Copy the link',
    'gift_link_copied': 'Link copied',
    'gift_share_text': '🎁 A gift for you: Hallouminati Adept — full prep for the Cyprus history and culture exam.',
    'gift_for_you': 'A gift for you',
    'gift_from': 'from :name',
    'gift_account_label': 'Goes to',
    'gift_not_you': 'Not you?',
    'gift_open_cta': 'Open the gift',
    'gift_open_failed': 'Couldn’t open the gift. Try again.',
    'gift_already_yours': 'This gift is already yours',
    'gift_already_opened': 'This gift has already been opened',
    'gift_not_found': 'Gift not found',
    'gift_own_title': 'Your gift for a friend',
    'gift_already_pro_title': 'You’re already an Adept',
    'gift_pass_on': 'Pass it to a friend',
    'gift_needs_account': 'Sign in to open the gift',

    // Quiz marks and history: the chip, «О вопросе», «Избранные», the lists
    // (docs/hallouminati/question-bank.md §Marks and history)
    'qs_stage_new': 'New',
    'qs_stage_learning': 'Learning',
    'qs_stage_almost': 'Almost learned',
    'qs_stage_learned': 'Learned',
    'qs_stage_known': 'Known',
    'qs_note_learning': 'To learn it, answer it right in Greek',
    'qs_note_almost': 'One right answer in Greek to go',
    'qs_note_learned': 'Counts towards your progress',
    'qs_note_known': 'You marked it yourself',
    'qs_how_title': 'How does it work?',
    'qs_how_new': 'Not answered yet',
    'qs_how_learning': 'No right answer yet',
    'qs_how_almost': 'Right in English. Greek to go',
    'qs_how_learned': 'Right in Greek',
    'qs_how_known': 'You marked it yourself',
    'qs_how_p1': 'A question counts towards your progress after its first right answer in Greek.',
    'qs_how_p2': 'It then comes back 4 more times, less and less often, so you don\'t forget it. After 5 right answers in a row it goes away for 60 days. The repeats don\'t change the percentage.',
    'qs_how_p3': 'A mistake stays in Mistakes until you answer it right. A learned question never leaves the percentage.',
    'qs_how_p4': 'Answers in English help you understand a question, but they don\'t count towards progress: the exam is in Greek.',
    'qs_how_p5': 'The percentage counts the core questions. Harder and rare ones are counted separately.',
    'qs_how_stages': 'Question stages',
    'qs_why_title': 'Why did this question come back?',
    'qs_why_p1': 'Each right answer in Greek in a row puts the question off for longer: 1, 3, 7, 21, then 60 days. A mistake brings it back tomorrow, a right answer in English in 3 days.',
    'qs_why_p2': 'That way easy questions go away on their own and hard ones stay close. A starred question comes back within 7 days.',
    'qs_why_p3': 'Sure you know it? "Mark as learned" takes it out at once.',
    'qs_sheet_title': 'About the question',
    'qs_repeats_left_one': 'One more right answer in Greek and it goes away for :days',
    'qs_repeats_left_many': ':count more right answers in Greek in a row and it goes away for :days',
    'qs_repeats_done': 'All :count repeats done',
    'qs_back_after_mistake': 'Back after a mistake on :date',
    'qs_back_after_other': 'Back :days after an answer in English',
    'qs_back_after_right': 'Back :days after a right answer',
    'qs_next_tomorrow': 'Back tomorrow',
    'qs_next_in': 'Next repeat in :days',
    'qs_next_due': 'Due now',
    'qs_known_out': 'Won\'t show it in practice again',
    'qs_right_count': ':count right',
    'qs_history_all': 'All :count',
    'qs_history_less': 'Show less',
    'qs_paper': 'Was on the exam, :month',
    'qs_error_rate': ':pct% of learners get it wrong',
    'qs_star_add': 'Star',
    'qs_mark_known_short': 'I know it',
    'qs_star_on': 'Starred',
    'qs_relearn': 'Learn again',
    'qs_answer': 'Answer',
    'qs_back_to_list': 'Back to the list',
    'qs_toast_starred': 'Starred',
    'qs_toast_unstarred': 'Star removed',
    'qs_toast_starred_back': 'Starred. It\'s back in practice',
    'qs_toast_known': 'Won\'t show it again',
    'qs_toast_known_unstar': 'Won\'t show it again. Star removed',
    'qs_toast_relearn': 'Back in practice',
    'qs_toast_greek': 'Questions are in Greek now',
    'qs_toast_error': 'That didn\'t work. Try again',
    'qs_starred_title': 'Starred',
    'qs_practise_all': 'Practise all :count',
    'qs_see_all': 'All :count',
    'qs_list_empty': 'Nothing here yet',
    'qs_empty_mistakes_title': 'No mistakes',
    'qs_empty_mistakes_text': 'A question you answer wrong lands here, and leaves once you answer it right.',
    'qs_empty_starred_title': 'No starred questions yet',
    'qs_empty_starred_text': 'Star a question in practice and it shows up here. A starred question comes back within a week.',
    'qs_all_questions': 'All questions in the topic',
    'qs_filter_all': 'All',
    'qs_filter_learning': 'Learning',
    'qs_filter_almost': 'Almost',
    'qs_filter_new': 'New',
    'qs_filter_learned': 'Learned',
    'qs_search': 'Search',
    'qs_nothing_found': 'Nothing found',
    'qs_more_rows': ':count more',
    'qs_other_language_line': 'We see your answers in English, but only Greek ones count',
    'qs_unstar_right': 'Unstar the right ones: :count',
    'qs_unstarred_done': 'Stars removed: :count',
    'qs_days_one': ':count day',
    'qs_days_few': ':count days',
    'qs_days_many': ':count days',
    'qs_answers_one': ':count answer',
    'qs_answers_few': ':count answers',
    'qs_answers_many': ':count answers',
    'qs_hist_right': 'right',
    'qs_hist_wrong': 'wrong',
    'qs_card_error': 'Couldn\'t load the question',
    'qs_back': 'Back',
};
